import * as React from "react";
import { PINResetForm } from "./PINResetForm";
import { OBRSettingsProvider } from "./OBRSettings";
import { useSearchParams } from "react-router-dom";

export const PINResetPage: React.FC = (props) => {
  const [searchParams] = useSearchParams();
  const borrowerNumber = parseInt(searchParams.get("borrowerNumber"));
  const verificationCode = searchParams.get("verificationCode");

  return (
    <OBRSettingsProvider>
      <PINResetForm
        borrowerNumber={borrowerNumber}
        verificationCode={verificationCode}
      ></PINResetForm>
    </OBRSettingsProvider>
  );
};
